// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import FileDragController from "./file_drag_controller";
application.register("file-drag", FileDragController);

import OutboxController from "./outbox_controller";
application.register("outbox", OutboxController);

import TableController from "./table_controller";
application.register("table", TableController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);
